import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import get from 'lodash/get';

import MetaTags from '~/components/MetaTags/MetaTags';
import Ad, { AdTypes } from '~/containers/AdContainer/AdContainer';
import { initStore } from '~/state/store';
import { operations as teamOperations } from '~/state/team';
import withState from '~/hocs/withState';
import { operations } from '~/state/pageData';

import Layout from '~/components/Layout/Layout';
import TeamBanner from '~/components/TeamBanner/TeamBanner';
import TeamRoster from '~/components/TeamRoster/TeamRoster';

import includes from 'lodash/includes';

import logEvent from '~/util/analytics';

import css from '~/pages/team.scss';

const getTeamIdFromState = state => get(state, 'teamData.data.id', '');

class Roster extends React.Component {
  static async getInitialProps(props) {
    const teamId = parseInt(props.query.teamId, 10);
    if (props.leagueSlug) {
      if (getTeamIdFromState(props.store.getState()) !== teamId) {
        const teamResult = await props.store.dispatch(
          teamOperations.setTeam(props.leagueSlug, teamId)
        );
        if (!teamResult || includes(teamResult.api_uri, '/error/events')) {
          // eslint-disable-next-line
          props.res.statusCode = 404;
        }
      }
      await props.store.dispatch(operations.setTeamRoster(props.leagueSlug, teamId));

      return {
        leagueSlug: props.leagueSlug,
      };
    }
    return { teamId };
  }

  componentDidMount() {
    logEvent({
      league: this.props.leagueSlug,
      page_type: 'team_roster',
      team_id: this.props.teamId,
    });
  }

  render() {
    const { leagueSlug, team } = this.props;
    let { teamRoster } = this.props;

    if (!Array.isArray(teamRoster)) {
      teamRoster = [];
    }

    return (
      <Layout>
        <Head>
          <style dangerouslySetInnerHTML={{ __html: css.stylesheet }} />
        </Head>
        <MetaTags content={team} type="team" />
        <div className={css.desktopView}>
          <Ad leagueSlug={leagueSlug} adType={AdTypes.LEADERBOARD} />
        </div>
        <TeamBanner team={team} currentSection="roster" />
        <TeamRoster players={teamRoster} />
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  team: state.teamData.data,
  teamRoster: state.pageData.roster,
});

Roster.propTypes = {
  leagueSlug: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  teamRoster: PropTypes.array.isRequired,
  teamId: PropTypes.string.isRequired,
};

Roster.displayName = 'RosterPage';

export default withState({
  createStore: initStore,
  mapStateToProps,
})(Roster);
